import { API_RANKINGS_PATH, getClient } from '../api';
import { Agent, IndividualRank } from '../dtos';

export async function getIndividualRank(agentId: NonNullable<Agent['id']>): Promise<IndividualRank[]> {
  const client = await getClient();
  const { data } = await client.get(`${API_RANKINGS_PATH}/individual/${agentId}`);

  return data;
}
